import { ConfirmationType } from "./types";

export default function(types: ConfirmationType[]): boolean {
    if(types.includes(ConfirmationType.Quick)) return false;

    return types.includes(ConfirmationType.Cancel) || types.includes(ConfirmationType.Long);
}